/**
 * SelectContentTypeSheet
 *
 * Helper to show the Select Content Type sheet using SheetService.
 */

import React from 'react';
import { SheetService } from '@/presentation/components/common/sheet/service/SheetService.index';
import { SelectContentTypeSheetContent } from './components/SelectContentTypeSheetContent';

interface SelectContentTypeSheetParams {
  title: string;
  description: string;
  canGoLive: boolean;
}

const show = (
  params: SelectContentTypeSheetParams,
  container?: HTMLElement | string | null,
  screenKey?: string,
  width?: string,
  fixedHeight?: string,
) => {
  const SheetContent: React.FC = () => {
    return (
      <SelectContentTypeSheetContent
        title={params.title}
        description={params.description}
        canGoLive={params.canGoLive}
        screenKey={screenKey}
        onClose={() => SheetService.close()}
      />
    );
  };

  SheetService.show({
    content: <SheetContent />,
    container,
    screenKey,
    width,
    fixedHeight,
    dismissible: true,
    closeOnClickOutside: true,
    scrollable: false,
  });
};

export const SelectContentTypeSheet = {
  show,
};
